import { render, staticRenderFns } from "./MyWorkflowsPage.vue?vue&type=template&id=c4cf5634&scoped=true&"
import script from "./MyWorkflowsPage.vue?vue&type=script&lang=js&"
export * from "./MyWorkflowsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4cf5634",
  null
  
)

export default component.exports